module.exports = __webpack_public_path__ + "img/access-denied.fbbee6d2.png";